var _style, _path, _rect, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _g3, _g4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g5, _path31, _path32, _g6, _path33, _rect2, _path34, _g7, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g8, _path53, _path54, _path55, _path56, _rect3, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _circle, _path78, _path79, _path80, _path81, _circle2, _circle3, _circle4, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 459.43 295.93",
    style: {
      enableBackground: "new 0 0 459.43 295.93"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{fill:#E09E7F;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#B9D3C1;}\n\t.st4{fill:#90AAB7;}\n\t.st5{fill:url(#SVGID_2_);}\n\t.st6{fill:url(#SVGID_3_);}\n\t.st7{fill:url(#SVGID_4_);}\n\t.st8{fill:url(#SVGID_5_);}\n\t.st9{fill:url(#SVGID_6_);}\n\t.st10{fill:url(#SVGID_7_);}\n\t.st11{fill:url(#SVGID_8_);}\n\t.st12{fill:url(#SVGID_9_);}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{fill:url(#SVGID_11_);}\n\t.st15{fill:url(#SVGID_12_);}\n\t.st16{fill:url(#SVGID_13_);}\n\t.st17{opacity:0.1;enable-background:new    ;}\n\t.st18{fill:url(#SVGID_14_);}\n\t.st19{fill:url(#SVGID_15_);}\n\t.st20{fill:url(#SVGID_16_);}\n\t.st21{fill:url(#SVGID_17_);}\n\t.st22{fill:url(#SVGID_18_);}\n\t.st23{fill:url(#SVGID_19_);}\n\t.st24{fill:url(#SVGID_20_);}\n\t.st25{fill:url(#SVGID_21_);}\n\t.st26{fill:url(#SVGID_22_);}\n\t.st27{fill:url(#SVGID_23_);}\n\t.st28{fill:url(#SVGID_24_);}\n\t.st29{fill:url(#SVGID_25_);}\n\t.st30{fill:#F8FAFB;}\n\t.st31{fill:url(#SVGID_26_);}\n\t.st32{fill:url(#SVGID_27_);}\n\t.st33{fill:url(#SVGID_28_);}\n\t.st34{fill:url(#SVGID_29_);}\n\t.st35{fill:url(#SVGID_30_);}\n\t.st36{fill:url(#SVGID_31_);}\n\t.st37{fill:url(#SVGID_32_);}\n\t.st38{fill:#B8C9D1;}\n\t.st39{fill:url(#SVGID_33_);}\n\t.st40{fill:url(#SVGID_34_);}\n\t.st41{fill:url(#SVGID_35_);}\n\t.st42{fill:url(#SVGID_36_);}\n\t.st43{fill:url(#SVGID_37_);}\n\t.st44{fill:url(#SVGID_38_);}\n\t.st45{fill:url(#SVGID_39_);}\n\t.st46{fill:url(#SVGID_40_);}\n\t.st47{fill:url(#SVGID_41_);}\n\t.st48{fill:url(#SVGID_42_);}\n\t.st49{fill:url(#SVGID_43_);}\n\t.st50{fill:url(#SVGID_44_);}\n\t.st51{fill:url(#SVGID_45_);}\n\t.st52{fill:url(#SVGID_46_);}\n\t.st53{fill:url(#SVGID_47_);}\n\t.st54{fill:url(#SVGID_48_);}\n\t.st55{fill:url(#SVGID_49_);}\n\t.st56{fill:url(#SVGID_50_);}\n\t.st57{fill:url(#SVGID_51_);}\n\t.st58{fill:url(#SVGID_52_);}\n\t.st59{fill:url(#SVGID_53_);}\n\t.st60{fill:url(#SVGID_54_);}\n\t.st61{fill:url(#SVGID_55_);}\n\t.st62{fill:url(#SVGID_56_);}\n\t.st63{fill:url(#SVGID_57_);}\n\t.st64{fill:url(#SVGID_58_);}\n\t.st65{fill:url(#SVGID_59_);}\n\t.st66{fill:url(#SVGID_60_);}\n\t.st67{fill:url(#SVGID_61_);}\n\t.st68{fill:url(#SVGID_62_);}\n\t.st69{fill:url(#SVGID_63_);}\n\t.st70{fill:url(#SVGID_64_);}\n\t.st71{fill:url(#SVGID_65_);}\n\t.st72{fill:url(#SVGID_66_);}\n\t.st73{fill:url(#SVGID_67_);}\n\t.st74{fill:url(#SVGID_68_);}\n\t.st75{fill:url(#SVGID_69_);}\n\t.st76{fill:url(#SVGID_70_);}\n\t.st77{fill:url(#SVGID_71_);}\n\t.st78{fill:url(#SVGID_72_);}\n\t.st79{fill:url(#SVGID_73_);}\n\t.st80{fill:url(#SVGID_74_);}\n\t.st81{fill:url(#SVGID_75_);}\n\t.st82{fill:url(#SVGID_76_);}\n\t.st83{fill:url(#SVGID_77_);}\n\t.st84{fill:url(#SVGID_78_);}\n\t.st85{fill:url(#SVGID_79_);}\n\t.st86{fill:url(#SVGID_80_);}\n\t.st87{fill:url(#SVGID_81_);}\n\t.st88{fill:url(#SVGID_82_);}\n\t.st89{fill:url(#SVGID_83_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.4812,
    y1: 125.4575,
    x2: 176.607,
    y2: -24.889,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.8,77.89L88.64,294.95h371.33l-1.05-139.2l-65.34-77.86C361.55,39.72,302.83,39.72,270.8,77.89z"
  }))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 338.96,
    y: 159.32,
    className: "st1",
    width: 4.62,
    height: 53.28
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 269.71,
    y: 67.54,
    className: "st2",
    width: 143.11,
    height: 92.08
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.18,69.23H267.3c-1.01,0-1.83-0.82-1.83-1.83l0,0c0-1.01,0.82-1.83,1.83-1.83h147.88 c1.01,0,1.83,0.82,1.83,1.83l0,0C417.01,68.41,416.19,69.23,415.18,69.23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.18,161.56H267.3c-1.01,0-1.83-0.82-1.83-1.83l0,0c0-1.01,0.82-1.83,1.83-1.83h147.88 c1.01,0,1.83,0.82,1.83,1.83l0,0C417.01,160.74,416.19,161.56,415.18,161.56z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.45,82.32v24.04c0,1.91-1.55,3.46-3.46,3.46h-24.04c-1.91,0-3.46-1.55-3.46-3.46V82.32 c0-1.91,1.55-3.46,3.46-3.46h24.04C307.9,78.85,309.45,80.4,309.45,82.32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M309.45,120.82v24.04c0,1.91-1.55,3.46-3.46,3.46h-24.04c-1.91,0-3.46-1.55-3.46-3.46v-24.04 c0-1.91,1.55-3.46,3.46-3.46h24.04C307.9,117.35,309.45,118.9,309.45,120.82z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M403.97,82.32v24.04c0,1.91-1.55,3.46-3.46,3.46h-42.2c-1.91,0-3.46-1.55-3.46-3.46V82.32 c0-1.91,1.55-3.46,3.46-3.46h42.2C402.42,78.85,403.97,80.4,403.97,82.32z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.63,214.53h-26.77c-1.07,0-1.93-0.86-1.93-1.93l0,0c0-1.07,0.86-1.93,1.93-1.93h26.77 c1.07,0,1.93,0.86,1.93,1.93l0,0C356.56,213.67,355.69,214.53,354.63,214.53z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M403.97,120.82v24.04c0,1.91-1.55,3.46-3.46,3.46h-42.2c-1.91,0-3.46-1.55-3.46-3.46v-24.04 c0-1.91,1.55-3.46,3.46-3.46h42.2C402.42,117.35,403.97,118.9,403.97,120.82z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M344.07,148.32h-24.04c-1.91,0-3.46-1.55-3.46-3.46V82.32c0-1.91,1.55-3.46,3.46-3.46h24.04 c1.91,0,3.46,1.55,3.46,3.46v62.54C347.54,146.77,345.99,148.32,344.07,148.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.5277,
    y1: -1401.6199,
    x2: 316.2422,
    y2: -1401.6199,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -769.7787 -838.5715)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DB1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDFFFF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M293.88,129.13c-0.99,0.5-3.73,4.59-5.13,5.87c-0.66,0.6-1.82,0.95-2.95,1.15c0.01,0.08,0.04,0.14,0.05,0.23 c0.06,0.36,0.11,0.76,0.14,1.21c-0.61,1.21-3.45,3.33-7.51,5.36c-2.54,1.27-5.54,2.51-8.77,3.47v-6.61 c2.72-1.3,5.93-2.65,8.77-3.96c1.84-0.85,3.52-1.68,4.82-2.47c0.09,0.02,0.18,0.04,0.27,0.06c0.25-0.52,0.45-1.11,0.49-1.42 c0.09-0.63,1.11-1.46,1.67-1.64c0.57-0.18,1.38-1.35,1.58-1.19c0.39,0.41,0.21,1.99-0.56,2.41c-0.81,0.42-1.32,0.78-1.08,2.06 c1.11-0.09,3.49-1.97,4.24-3.19C290.65,129.25,292.89,127.9,293.88,129.13z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.97,98.36h-4.18c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.18c0.2,0,0.36,0.16,0.36,0.36 C302.32,98.2,302.16,98.36,301.97,98.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.94,98.36h-9.98c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h9.98c0.2,0,0.36,0.16,0.36,0.36 S296.14,98.36,295.94,98.36z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.97,91.02h-4.18c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.18c0.2,0,0.36,0.16,0.36,0.36 C302.32,90.86,302.16,91.02,301.97,91.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.94,91.02h-9.98c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h9.98c0.2,0,0.36,0.16,0.36,0.36 C296.3,90.86,296.14,91.02,295.94,91.02z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.15,94.94h-4.18c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.18c0.2,0,0.36,0.16,0.36,0.36 C290.51,94.78,290.35,94.94,290.15,94.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.97,94.94h-9.98c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h9.98c0.2,0,0.36,0.16,0.36,0.36 C302.32,94.78,302.16,94.94,301.97,94.94z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340.05,98.36h-4.18c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.18c0.2,0,0.36,0.16,0.36,0.36 C340.41,98.2,340.25,98.36,340.05,98.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M334.03,98.36h-9.98c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h9.98c0.2,0,0.36,0.16,0.36,0.36 C334.39,98.2,334.23,98.36,334.03,98.36z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340.05,91.02h-4.18c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.18c0.2,0,0.36,0.16,0.36,0.36 C340.41,90.86,340.25,91.02,340.05,91.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M334.03,91.02h-9.98c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h9.98c0.2,0,0.36,0.16,0.36,0.36 C334.39,90.86,334.23,91.02,334.03,91.02z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.24,94.94h-4.18c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.18c0.2,0,0.36,0.16,0.36,0.36 C328.59,94.78,328.43,94.94,328.24,94.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340.05,94.94h-9.98c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h9.98c0.2,0,0.36,0.16,0.36,0.36 C340.41,94.78,340.25,94.94,340.05,94.94z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340.05,113.36h-4.18c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.18c0.2,0,0.36,0.16,0.36,0.36 C340.41,113.21,340.25,113.36,340.05,113.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M334.03,113.36h-9.98c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h9.98c0.2,0,0.36,0.16,0.36,0.36 C334.39,113.21,334.23,113.36,334.03,113.36z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340.05,106.03h-4.18c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.18c0.2,0,0.36,0.16,0.36,0.36 C340.41,105.87,340.25,106.03,340.05,106.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M334.03,106.03h-9.98c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h9.98c0.2,0,0.36,0.16,0.36,0.36 C334.39,105.87,334.23,106.03,334.03,106.03z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.24,109.94h-4.18c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h4.18c0.2,0,0.36,0.16,0.36,0.36 C328.59,109.78,328.43,109.94,328.24,109.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340.05,109.94h-9.98c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h9.98c0.2,0,0.36,0.16,0.36,0.36 C340.41,109.78,340.25,109.94,340.05,109.94z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.7783,
    y1: -1396.5002,
    x2: 358.33,
    y2: -1396.5002,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -757.1561 -810.8605)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M340.05,131.37c0,4.42-3.59,8-8,8s-8-3.58-8-8c0-4.41,3.59-7.99,8-7.99v7.99H340.05z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M338.67,129.99h-5.24v-5.23C336.32,124.76,338.67,127.1,338.67,129.99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.6755,
    y1: 74.9117,
    x2: 277.6852,
    y2: 74.9117,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M277.11,219.82c0.42,0.49,0.61,0.93,0.57,1.19s-0.1,1.09-2.14,1.92c-2.71,1.1-4.37,0.83-7.5,0.86 c-2.95,0.03-4.32-0.06-4.98-0.97s-0.27-3.34-0.27-3.34l6.29,0.66L277.11,219.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.94,
    y1: 77.4137,
    x2: 277.2987,
    y2: 77.4137,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90AAB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9D3C1"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M266.03,215.93c1.52,1.07,3.25,1.53,5.04,2.18c1.09,0.4,3.69,0.71,4.79,1.02s1.64,0.95,1.37,1.33 c-0.27,0.38-2.09,1.42-3.78,1.66c-2.95,0.43-4.66,0.12-7.31,0.07c-2.52-0.05-3.3-0.72-3.44-1.64s-0.76-3.52-0.76-3.52 L266.03,215.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.3088,
    y1: 77.2466,
    x2: 257.2491,
    y2: 77.2466,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M256.83,218.9c0.35,0.55,0.47,1.01,0.4,1.26c-0.07,0.26-0.25,1.06-2.39,1.6c-2.83,0.71-4.35,0.07-7.85-1.02 c-2.82-0.88-3.96,0.15-4.49-0.85s0.21-3.34,0.21-3.34l6.13,1.54L256.83,218.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.22,
    y1: 79.4862,
    x2: 256.9625,
    y2: 79.4862,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90AAB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9D3C1"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M246.41,213.48c1.35,1.27,3,1.97,4.68,2.87c1.02,0.55,3.55,1.22,4.6,1.68c1.05,0.46,1.49,1.17,1.17,1.51 c-0.32,0.34-2.27,1.11-3.97,1.11c-2.98,0-3.7-0.94-6.32-1.36c-2.49-0.4-4.09-0.78-4.1-1.72c-0.01-0.94-0.25-3.59-0.25-3.59 L246.41,213.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.6492,
    y1: -1449.7805,
    x2: 291.4435,
    y2: -1449.7805,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -803.6924 -847.7556)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4B38A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9D7BB"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M247.43,158.51c0.05,7.86-1.06,24.65-0.67,30.6c-3.03,7.5-5.76,17.84-4.72,24.83 c0.79,1.13,3.26,1.37,4.71,0.41c1.07-4.25,5.52-22.31,5.99-24.83c0.99-4.7,8.4-22.52,5.2-29.23 C254.87,158.65,247.43,158.51,247.43,158.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.8624,
    y1: -1450.0391,
    x2: 296.713,
    y2: -1450.0391,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -801.5605 -845.0159)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4B38A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9D7BB"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M265.35,191.23c0.73,6.76,1.4,21.35,1.48,25.2c-0.37,0.32-3.45,1.41-4.83,0.93 c-0.96-7.58-4.99-17.97-2.95-24.46c-1.19-6.55-5.07-17.45-5.65-26.12c-8.74-4.1-8.66-7.79-8.85-13.3l10.76,0.02l3.43-1.56 C258.74,151.94,265.94,171.23,265.35,191.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.8946,
    y1: -1388.0464,
    x2: 310.4653,
    y2: -1388.0464,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -761.3848 -839.965)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EACEBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE9166"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M278.46,126.69c1.39-1.3,1.28-2.46,1.66-4.01c0.39-1.55,3.49-4.01,5.41-4.07c1.93-0.05,3.56,0.37,3.56,0.37 c-1.33,1.67-4.08,1.63-5.01,3.12c-0.93,1.49-1.4,2.2-1.79,2.73c1.21-0.44,1.61-1.61,2.48-2.27c0.87-0.66,1.58-1.48,2.23-0.84 c-0.65,0.61-1.69,1.68-2.07,2.24c-0.37,0.56-1.02,3.22-2.33,3.21c-1.31,0-2.26,0.37-2.99,1.12 C278.88,129.05,278.46,126.69,278.46,126.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.9217,
    y1: -1394.6028,
    x2: 300.4792,
    y2: -1394.6028,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -769.4271 -848.8494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M256.27,122.6c2.72,1.34,9.58,9.1,11.32,12.8c2.15-3.56,8.65-8.05,10.48-9.42c1.25-1.21,3.83,1.68,2.65,2.76 c-1.23,1.86-11.33,10.39-13.23,12.2c-1.9,1.8-17.17-14.5-17.17-14.5L256.27,122.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.5461,
    y1: -1391.1091,
    x2: 317.2743,
    y2: -1391.1091,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -761.8142 -836.4304)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M283.26,132.02l-0.12-0.12c-0.37-0.37-0.37-0.98,0-1.36l10.61-10.61c0.37-0.37,0.98-0.37,1.36,0l0.12,0.12 c0.37,0.37,0.37,0.98,0,1.36l-10.61,10.61C284.24,132.4,283.63,132.4,283.26,132.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.5398,
    y1: -1401.2705,
    x2: 284.0221,
    y2: -1401.2705,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -774.9219 -855.9041)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M242.83,128.74c0.09,0.47,0.19,0.97,0.32,1.49c1.88,7.71-1.77,10.02,0.83,21.97c0.12,0.54,0.24,1.1,0.36,1.68 c1.03,4.98,14.86,0.7,14.82-1.18c-0.1-5.17,2.07-15.21,1.75-21.06c-0.03-0.57-0.06-1.16-0.07-1.77c-0.02-0.76-0.2-1.51-0.56-2.19 c-1.76-3.35-6.11-8.62-6.11-8.62l-8.5-1.2C244.5,120.65,241.6,122,242.83,128.74z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M243.94,125.32c1.1,5.2,5.14,16.84,15.86,19.65c0.37-2.94,0.2-5.65,0.42-8.72c-1.23-1.46-2.85-6.61-5.54-9.39 c-2.82-2.91-3.67-4.26-3.67-4.26L243.94,125.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.56,
    y1: 186.9361,
    x2: 262.78,
    y2: 186.9361,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EACEBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE9166"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M246.56,116.94l0.17,0.02l3.6,0.39l1.46,0.16l0.29-2.75c1.66,1.85,4.23,3.55,6.62-0.08 c1.78-2.64,2.88-4.59,3.59-7.6c0.19-0.79,0.35-1.65,0.49-2.62l-14.9-2.74l-1.31,15.17L246.56,116.94z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M246.57,116.88l0.16,0.08l3.46,1.65c-0.05-0.43,0.02-0.84,0.15-1.25c0.44-1.44-0.02-1.92-0.14-3.45 c-0.03-0.35,0.49-2.12,0.58-2.46c0.22-0.83,2.39-0.44,3.02-1.01c1.21-1.1,0.41-3.31,1.42-4.6c0.45-0.59,1.21-0.87,1.96-0.92 c0.74-0.04,1.48,0.13,2.2,0.29l2.92,1.88c0.19-0.79,0.35-1.65,0.49-2.62l-14.9-2.74L246.57,116.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.7195,
    y1: -1368.0117,
    x2: 281.94,
    y2: -1368.0117,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -754.792 -860.0494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3726,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5069,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6026,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9069,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9523,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9926,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M247.19,109.4c2.68-0.04,1.08-3.54,3.15-3.54c2.07,0,1.14,2.71,2.73,1.46c2.15-1.49,2.3-3.45,5.38-2.39 s2.09-0.69,3.85,2.16c1.63-2.41,1.78-3.97,0.49-5.37c-1.4-1.53-1.48-2.5-3.63-3.34c-1.75-0.69-1.59-2.89-5.13-0.89 c-1.22-1.35-4.92-0.58-5.06,1.23C245.99,99.61,246.86,104.59,247.19,109.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.0638,
    y1: -1393.6978,
    x2: 314.382,
    y2: -1393.6978,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -763.6416 -837.0358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EACEBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE9166"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M282.86,132.5c0.75-0.09,4.48-0.21,5.88-1.49s4.15-5.37,5.13-5.88c-0.98-1.22-3.22,0.12-3.97,1.34 c-0.75,1.22-3.13,3.1-4.24,3.19c-0.24-1.28,0.27-1.64,1.07-2.06c0.78-0.42,0.95-2,0.57-2.42c-0.2-0.15-1.01,1.01-1.58,1.19 c-0.57,0.18-1.58,1.01-1.67,1.64c-0.09,0.63-0.83,2.43-1.34,2.48c-0.52,0.04-2,0.81-2,0.81L282.86,132.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.3539,
    y1: -1394.1238,
    x2: 299.1476,
    y2: -1394.1238,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -769.6757 -850.1505)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M243.98,124.96c0.02,0.94,0.41,1.94,1.24,2.9c3.97,4.54,8.71,13.87,19.1,15.21 c9.48-2.32,17.59-7.34,18.67-9.48c-0.03-0.45-0.08-0.85-0.14-1.21c-0.44-2.46-1.53-2.76-2.55-3c-3.84,2.33-11,5.01-15.57,7.43 c-7.63-5.12-8.92-6.83-14.14-15.53C248.69,118.1,243.88,122.02,243.98,124.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.0303,
    y1: -1384.2131,
    x2: 274.087,
    y2: -1384.2131,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -764.5887 -859.6205)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M253.79,117.81l3.05,3.46c0.05,0.06,0,0.16-0.08,0.14l-11.59-2.76l1.11-2.5l6.14,0.92 C252.95,117.15,253.43,117.41,253.79,117.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.3791,
    y1: -1479.6555,
    x2: 240.3246,
    y2: -1479.6555,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -826.2097 -863.5518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M226.74,223.01H201.2v-16.96h9.38c3.87,0,7.51,2.3,9.81,6.18L226.74,223.01z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.73,250.38c-0.35,0-0.7-0.19-0.88-0.52c-0.26-0.48-0.08-1.09,0.4-1.36c2.81-1.53,7.68-2.44,13.04-2.44 c0.55,0,1,0.45,1,1s-0.45,1-1,1c-4.97,0-9.6,0.84-12.09,2.2C186.06,250.34,185.89,250.38,185.73,250.38z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.3699,
    y1: -1515.6525,
    x2: 206.5545,
    y2: -1515.6525,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -852.1454 -873.8118)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M182.64,250.53c0-1.16,0.94-2.09,2.09-2.09c1.16,0,2.09,0.94,2.09,2.09c0,1.16-0.94,2.09-2.09,2.09 C183.57,252.63,182.64,251.69,182.64,250.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.7923,
    y1: -1519.6492,
    x2: 219.98,
    y2: -1519.6492,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -852.0117 -865.3881)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M196.06,254.53c0-1.16,0.94-2.09,2.09-2.09c1.16,0,2.09,0.94,2.09,2.09c0,1.16-0.94,2.09-2.09,2.09 C197,256.63,196.06,255.69,196.06,254.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.58,250.38c0.35,0,0.7-0.19,0.88-0.52c0.26-0.48,0.08-1.09-0.4-1.36c-2.81-1.53-7.68-2.44-13.04-2.44 c-0.55,0-1,0.45-1,1s0.45,1,1,1c4.97,0,9.6,0.84,12.09,2.2C210.25,250.34,210.42,250.38,210.58,250.38z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.2173,
    y1: -1515.6552,
    x2: 233.4051,
    y2: -1515.6552,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -847.2896 -858.4113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M213.67,250.53c0-1.16-0.94-2.09-2.09-2.09c-1.16,0-2.09,0.94-2.09,2.09c0,1.16,0.94,2.09,2.09,2.09 C212.74,252.63,213.67,251.69,213.67,250.53z"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 196.45,
    y: 222.77,
    className: "st1",
    width: 3.42,
    height: 24.61
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.5478,
    y1: -1473.647,
    x2: 231.8738,
    y2: -1473.647,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -826.3917 -874.535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M185.07,190.71h-8.23c-3.12,0-5.33,3.06-4.34,6.02l8.79,26.42c0.95,2.86,3.63,4.79,6.64,4.79h24.59 c2.71,0,5.18-1.57,6.34-4.02l1.16-2.46c2.07-4.41-1.15-9.48-6.02-9.48h-21.76L185.07,190.71z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "262.82,204.29 262.04,206.66 262,206.78 256.68,223.34 255.9,225.77 246.35,255.49 243.66,255.49  259.32,206.78 260.37,203.5 261.59,203.89  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "293.46,255.49 290.76,255.49 281.21,225.77 280.43,223.34 275.11,206.78 275.07,206.66  274.3,204.29 275.52,203.89 276.75,203.5 277.8,206.78  "
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.1264,
    y1: -1466.3053,
    x2: 259.3504,
    y2: -1466.3053,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -815.0161 -853.7324)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C1845D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7350"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M229.39,201.75l1.69,0.07c0,0,0.31,1.61,0.91,1.97c0.61,0.36,2.7,0.35,3.03,0.78c1.41-0.82,1.81-0.95,2.1-0.9 c-0.49-0.6-1.51-0.52-2.06-0.17c-0.78-0.22-1.58-0.55-1.58-0.55c0.78-0.37,2.86-1.57,4.08-0.84c1.22,0.73,3.34,0.51,3.31,0.12 c-0.57-0.87-0.88-1.79-1.9-2.1c-1.02-0.31-2.99-1.66-4.37-1.23c-1.38,0.43-2.51,0.62-3.07,0.73c-0.56,0.11-1.73-0.08-1.73-0.08 L229.39,201.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.3115,
    y1: 43.1234,
    x2: 248.7085,
    y2: 43.1234,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M248.17,252.23c0.41,0.53,0.58,0.99,0.53,1.25c-0.05,0.27-0.16,1.11-2.3,1.86 c-2.83,0.99-4.47-0.33-7.67-0.46c-3.02-0.12-4.48,0.66-5.11-0.3s-0.1-3.43-0.1-3.43l6.41,1.01L248.17,252.23z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M237.02,247.67c1.5,1.18,3.25,1.74,5.05,2.5c1.1,0.46,3.74,0.92,4.85,1.29s1.63,1.06,1.34,1.43 c-0.3,0.38-2.21,1.34-3.96,1.5c-3.04,0.28-4.09-1.03-6.8-0.83c-2.75,0.21-4.04-0.4-4.14-1.35c-0.1-0.95-0.59-3.65-0.59-3.65 L237.02,247.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.4443,
    y1: 42.1943,
    x2: 232.7438,
    y2: 42.1943,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M232.33,254.08c0.35,0.57,0.47,1.04,0.39,1.3c-0.08,0.26-0.28,1.09-2.48,1.6c-2.92,0.67-4.56,0.13-7.73-0.35 c-2.99-0.45-4.37-0.77-4.89-1.79c-0.52-1.03,0.28-3.42,0.28-3.42l6.26,1.7L232.33,254.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.7224,
    y1: -1493.4653,
    x2: 253.1653,
    y2: -1493.4653,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -832.8734 -858.3209)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M214.72,219.38c5.28,0.07,1.26,1.33,9.75,0.94c0,10.62,2.85,13.3,8.3,28.26c0.38,1.87,4.95,1.9,5.24-0.51 c-1.34-5.98-1.94-10.86-7.96-29c-0.62-1.87-2.09-4.3-4-4.83c-9.92-2.75-14.56-3.61-19.9-3.93c-0.23-1.36-1.15-7.2-3.71-3.68 c-0.88,1.2-2.61,5.86-2.6,7.13C199.9,221.31,207.23,219.41,214.72,219.38z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M221.75,248.33c1.36,1.33,3.04,2.08,4.75,3.04c1.04,0.58,3.62,1.32,4.69,1.81c1.06,0.49,1.51,1.23,1.17,1.57 c-0.34,0.34-2.35,1.09-4.1,1.06c-3.05-0.05-4.74-0.64-7.42-1.13c-2.55-0.46-3.22-1.26-3.22-2.22c0.01-0.96-0.19-3.69-0.19-3.69 L221.75,248.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.3831,
    y1: -1492.953,
    x2: 246.3376,
    y2: -1492.953,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -835.3993 -865.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M224.97,221.56c-1.94,15.9-1.21,20.24-2.77,26.87c-0.24,2.03-3.19,2.44-4.34,1.39 c-0.22-0.19-0.37-0.44-0.43-0.73c0.25-7.29-2.58-15.11,0.85-26.53c-5.75,0.4-9.5,0.77-14.77,0.41c-7.64-0.52-15.42-1.59-16-8.44 c-0.03-0.25-0.04-0.51-0.04-0.78c-0.01-1.27,1.72-5.93,2.6-7.13c2.12-2.92,3.62,3.37,3.79,4.09c-0.02-0.07-0.04-0.21-0.08-0.41 c7.09,0.04,12.64,2.45,25.69,5.01C222.66,215.93,225.36,218.34,224.97,221.56z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M220.01,223.99c-1.23,4.87-1.45,9.93-1.67,14.94c-0.16,3.63-0.32,7.26-0.48,10.89 c-0.22-0.19-0.37-0.44-0.43-0.73c0.25-7.29-2.58-15.11,0.85-26.53c-5.75,0.4-9.5,0.77-14.77,0.41c-7.64-0.52-15.42-1.59-16-8.44 c0.75,0.24,1.6,1.04,2.04,1.33c1.42,0.95,2.95,1.75,4.54,2.38c1.82,0.71,3.72,1.2,5.65,1.44c5.66,0.71,11.37-0.65,17.07-0.6 c1.07,0.01,2.27,0.13,2.97,0.93C220.7,221.05,220.34,222.64,220.01,223.99z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M231.6,202.25c-0.18,0.24-0.41,0.39-0.71,0.39c-1.42,0-18.17-0.91-19.42-1.83c-1-1.5-6.81-13.67-6.81-13.67 l1.27-3.2l2.24-5.67c2.8,3.37,5.8,12.64,7.3,18.23c3.67-0.09,13.83,1.43,15.75,2.43C232.07,199.26,232.25,201.37,231.6,202.25z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M231.6,202.25c-0.18,0.24-0.41,0.39-0.71,0.39c-1.42,0-18.17-0.91-19.42-1.83c-1-1.5-6.81-13.67-6.81-13.67 l1.27-3.2c0.28,0.65,0.49,1.31,0.7,1.79c1.66,3.75,3.34,7.53,5.79,10.81c0.68,0.9,1.44,1.79,2.45,2.3c1.47,0.73,3.2,0.54,4.84,0.49 c3.5-0.09,7.01,0.54,10.25,1.85C230.56,201.43,231.2,201.77,231.6,202.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.8276,
    y1: -1434.1019,
    x2: 231.8353,
    y2: -1434.1019,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -802.9579 -878.8544)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C1845D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7350"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M204.59,174.12c-0.36,0.06-0.77,0-1.2-0.13c-0.59-0.18-1.21-0.49-1.7-0.78c0,0-0.14,1.48-0.29,5.04 c-0.03,0.7-5.75,1.49-5.75,1.49l-1.31-4.78c0,0,1.17-1.52,1.23-3.23c0.04-0.88,0.02-1.77-0.11-2.43c-0.4-1.92-0.53-4.37,1.69-7.11 c1.93-2.39,7.24-1.97,8.96-1.8c0.25,0.02,0.42,0.04,0.5,0.04c0.38,0.02,0.81-0.12,1.15,0.09v0.01c0.24,0.14,0.44,0.44,0.54,1.07 C208.31,161.62,208.25,173.51,204.59,174.12z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M204.7,162.89c-0.68,0.11-1.4,0.27-1.88,0.76c-0.65,0.67-0.64,1.73-0.62,2.67c0.01,0.94-0.08,2.02-0.84,2.58 c-0.82,0.6-2.02,0.27-2.93,0.73c-0.88,0.44-1.29,1.52-2.17,1.96c-0.22,0.11-0.45,0.17-0.69,0.17c0.04-0.88,0.02-1.77-0.11-2.43 c-0.4-1.92-0.53-4.37,1.69-7.11c1.93-2.39,7.24-1.97,8.96-1.8c0.17,0.27,0.38,0.51,0.63,0.72 C207.88,162.06,205.35,162.78,204.7,162.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.6235,
    y1: 134.4774,
    x2: 209.0667,
    y2: 134.4774,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3726,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5069,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6026,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9069,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9523,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9926,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M208.24,162.11c1.85-2.88,0.4-5.8-2.42-5.8c-1.75-1.88-4.19-1.9-5.99-0.53c-0.99,0.05-2.57,0.11-3.3,1.99 c-2.46,0.57-3.16,2.5-2.83,5.57c0,2.22,0.92,4,1.77,5.99c1.62-1.53-0.03-3.4,0.91-4.27c0.83-0.77,1.95,0.26,2.27,1.33 c0.26,0.15,1.54,0.13,1.54,0.13l-0.2-4.42C202.38,160.45,206.54,160.85,208.24,162.11z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M201.71,173.23c-1.78-1.22-3.43-2.68-3.84-3.25c0.03,1.33,1.34,3.41,3.69,4.25 C201.59,173.99,201.71,173.23,201.71,173.23z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M200.09,175.08l-6.34,0.95l-6.91,2.69c-0.52,0.6,0.91,2.59,0.66,4.58c0,0,0.81,13.75,1.21,24.9 c0.19,5.17,18.87,5.72,17.96,1.12c-0.89-4.5,0.65-18.58,0.47-24.95c-0.08-2.62,3.42-4.15,1.02-6.11L200.09,175.08z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M191.13,181.55c2.34,6.52,2.5,14.43,2.5,14.43s8.16-0.34,12.88,2.79c-0.12,0.96-1.84,4.21-1.84,4.21 l-15.61-2.35c0,0-3.25-9.77-3.17-10.17C185.97,190.06,191.13,181.55,191.13,181.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.02,
    y1: 106.5762,
    x2: 204.5559,
    y2: 106.5762,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M203.89,188.39c-0.89-3.4-1.98-6.34-3.08-8.83l1.04-2.6l-2-1.88l-2.83,1.87l2.8,2.74 c-0.02,0.01-0.03,0.02-0.05,0.04c0.54,2.71,0.99,5.73,1.26,9.04c0.36,4.47-0.9,9.24-1.15,12.74c0.96,1.12,1.92,2.24,2.89,3.36 c0.58-1.4,1.16-2.81,1.73-4.21C204.32,197.43,205.03,192.76,203.89,188.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.6559,
    y1: -1482.0469,
    x2: 223.6032,
    y2: -1482.0469,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -830.6018 -872.7133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M210.02,225.4h-25.54v-16.96h9.38c3.87,0,7.52,2.3,9.81,6.18L210.02,225.4z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "176.82,204.29 176.04,206.66 176,206.78 170.68,223.34 169.9,225.77 160.35,255.49 157.66,255.49  173.32,206.78 173.33,206.73 174.37,203.5 175.59,203.89  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "207.46,255.49 204.76,255.49 195.21,225.77 194.43,223.34 189.11,206.78 189.07,206.66  188.3,204.29 189.52,203.89 190.75,203.5 191.8,206.78  "
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.86,206.79H173.8c-1.14,0-2.07-0.93-2.07-2.07l0,0c0-1.14,0.93-2.07,2.07-2.07h111.06 c1.14,0,2.07,0.93,2.07,2.07l0,0C286.93,205.86,286.01,206.79,284.86,206.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M201.42,206.79H164.7c-1.14,0-2.07-0.93-2.07-2.07l0,0c0-1.14,0.93-2.07,2.07-2.07h36.72 c1.14,0,2.07,0.93,2.07,2.07l0,0C203.49,205.86,202.56,206.79,201.42,206.79z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.9709,
    y1: -1465.6893,
    x2: 237.4104,
    y2: -1465.6893,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -818.4135 -866.6406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C1845D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7350"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M207.22,199.8l1.7,0.28c0,0,0.47-1.57,1.11-1.87c0.64-0.3,2.72-0.07,3.1-0.46c1.32,0.96,1.7,1.13,2,1.11 c-0.55,0.54-1.55,0.37-2.07-0.04c-0.8,0.14-1.63,0.39-1.63,0.39c0.73,0.45,2.69,1.86,3.98,1.25c1.29-0.6,3.38-0.16,3.3,0.22 c-0.65,0.81-1.06,1.69-2.11,1.89c-1.05,0.21-3.14,1.34-4.47,0.78s-2.4-0.72-2.95-0.88c-0.55-0.17-1.96-0.04-1.96-0.04L207.22,199.8 z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M186.78,178.82c-1.93,0.93-3.07,15.81-0.81,23.83c7.23,1.23,17.09,0.48,23.05,0c0.92-0.07,1-3.21-0.8-3.58 c-2.88-0.59-13.29-1.84-16.99-1.91c0.83-4.88,0.62-12.51-0.21-16.19C190.37,178.12,187.93,178.27,186.78,178.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.2961,
    y1: -1466.7509,
    x2: 261.8997,
    y2: -1466.7509,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -814.7047 -853.1362)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9BACB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBFCFF"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M242.67,202.65h-12.19c-0.38,0-0.69-0.31-0.69-0.69v-0.93c0-0.38,0.31-0.69,0.69-0.69h12.19V202.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.7957,
    y1: -1459.8782,
    x2: 290.3233,
    y2: -1459.8782,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -807.7498 -844.4525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0BEC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M261.09,202.65h-23.38l6.27-14.9c0.2-0.47,0.65-0.77,1.16-0.77h23.35c0.55,0,0.92,0.56,0.71,1.06l-5.39,12.81 C263.35,201.94,262.27,202.65,261.09,202.65z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 197.01,
    y: 246.15,
    className: "st1",
    width: 2.28,
    height: 6.82
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M199.85,175.09l-1.59,4.72c-0.78-0.13-2.12-0.68-2.95-1.09c-1-0.5-1.72-1.67-2.1-2.2 c0.51-0.72,0.78-1.24,1.3-1.96C194.5,174.56,197.26,175.52,199.85,175.09z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M199.85,175.09l2.35,3.95l1.29-2.43l-1.75-1.86C201.74,174.75,200.53,175.03,199.85,175.09z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.663,
    y1: -1375.4204,
    x2: 442.68,
    y2: -1375.4204,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -730.2866 -766.267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M412.17,100.68c-0.1,3.09-2.78,5.63-2.9,8.72c-0.08,1.9,0.85,3.72,2.07,5.18s2.72,2.65,4.09,3.97 c0.43,0.41,0.85,0.86,1.02,1.43c0.16,0.57-0.03,1.29-0.58,1.52c1.4-0.53,2.66-0.82,3.92-1.63s2.37-1.91,2.93-3.3 c0.78-1.95,0.36-4.16-0.23-6.18c-0.72-2.49-1.71-4.98-3.45-6.91C417.3,101.56,414.74,100.3,412.17,100.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.248,
    y1: -1388.4559,
    x2: 403.2935,
    y2: -1388.4559,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -743.5792 -784.9114)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M385.46,124.38c-1.52-0.69-1.75-1.68-2.5-2.86c-0.75-1.17-4.02-2.35-5.63-1.86c-1.61,0.5-2.85,1.31-2.85,1.31 c1.57,1.01,3.85,0.21,5.04,1.19s2.54,1.99,3.01,2.32c-1.12-0.03-2.55-1.44-3.45-1.74c-0.91-0.3-1.72-0.78-2.08-0.07 c0.71,0.32,1.88,0.92,2.34,1.28c0.47,0.36,1.75,2.38,2.83,2.01c1.08-0.37,1.98-0.33,2.8,0.09 C385.77,126.45,385.46,124.38,385.46,124.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.6204,
    y1: -1394.6266,
    x2: 432.2534,
    y2: -1394.6266,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -745.3242 -775.0977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DB1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDFFFF"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M413.21,125.83l-2.69-3.01l-6.81,8.59c-0.89,1.05-2.3,1.49-3.62,1.14c-3.38-0.91-9.89-2.63-13.44-3.34 c-0.29,0.28-0.52,0.63-0.73,1c-1.24-0.54-1.6-1.42-2.4-2.4c-0.88-1.08-4.25-1.9-5.8-1.22c-1.55,0.67-2.69,1.61-2.69,1.61 c1.67,0.83,3.85-0.22,5.14,0.62s2.75,1.7,3.25,1.97c-1.12,0.1-2.69-1.15-3.63-1.35c-0.94-0.2-1.8-0.59-2.08,0.16 c0.74,0.24,1.97,0.71,2.47,1.01c0.5,0.3,2,2.17,3.04,1.69c0.75-0.35,1.42-0.47,2.07-0.39c-0.1,0.48-0.15,0.97-0.16,1.45 c0,0.12,8.33,2.8,13.54,4.47c2.54,0.81,5.31,0.18,7.25-1.65l8.43-7.94L413.21,125.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.0235,
    y1: -1390.6281,
    x2: 432.0943,
    y2: -1390.6281,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -742.395 -773.4636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M385.91,123.26c-0.44,0.34-0.81,0.78-1.11,1.3c-0.47,0.79-0.75,1.73-0.86,2.65 c-0.01,0.12,7.97,3.71,12.97,5.94c2.43,1.09,5.26,0.76,7.39-0.84l9.26-6.96l-0.86-2.52l-2.34-3.29l-7.71,7.79 c-1,0.95-2.45,1.23-3.73,0.73C395.64,126.78,389.36,124.35,385.91,123.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.9867,
    y1: -1383.608,
    x2: 444.9804,
    y2: -1383.608,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -734.2622 -763.2841)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M425.74,117.55c-1.09-0.73-3.31-2.66-3.36-4.09c-1.84,0.23-5.11-1.36-5.32-0.09 c-0.41,2.47-3.27,3.72-3.27,3.72l-1.64,5.45l4.12,2.31l6.03-2.25L425.74,117.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.2797,
    y1: 81.1388,
    x2: 425.5078,
    y2: 81.1388,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M421.92,212.08c-0.11,0.05-0.22,0.1-0.33,0.15c-2.72,1.16-7.37,2.2-9.67,4.51c-2.4,2.41,2.44,3.35,6.36,2.37 c3.69-0.92,5.09-1.72,6.24-2.17c1.27-0.5,1.18-2.35,0.49-4.54C424.3,210.2,421.92,212.08,421.92,212.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.0993,
    y1: -1398.0433,
    x2: 451.6701,
    y2: -1398.0433,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -742.3307 -762.2339)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M424.27,116.36c-3.5,3.34-10.22,8.26-10.42,3.07c-1.39,2.93-5.98,9.8-4.76,13.82s2.44,14.73,2.44,14.73 s6.32,0.07,6.31-0.24c-0.01-0.31,3.32-21.02,3.32-21.02L424.27,116.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.1878,
    y1: -1479.6122,
    x2: 444.8242,
    y2: -1479.6122,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -788.632 -745.9907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M424.33,212.74c-0.86,2.23-2.74,3.14-6.29,4.08c-4.07,1.08-5.68-0.98-1.73-2.65 c1.09-0.46,4.97-1.71,5.53-3.05s2.37-0.54,2.37-0.54L424.33,212.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.2782,
    y1: 73.1035,
    x2: 424.12,
    y2: 73.1035,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M419.42,219.12c-0.08,0.08-0.17,0.16-0.26,0.25c-2.19,1.99-6.23,4.51-7.64,7.45 c-1.47,3.07,4.13,3.03,6.89,0.41c2.76-2.63,3.86-3.3,5.32-4.59c0.92-0.81,0.1-2.39-1.29-4.23 C421.05,216.55,419.42,219.12,419.42,219.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.4567,
    y1: -1486.5421,
    x2: 442.823,
    y2: -1486.5421,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -793.2614 -745.2571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M421.91,218.94c-0.08,2.39-2.44,3.58-4.59,5.93c-2.2,2.41-4.2,0.28-2.58-1.57c0.78-0.89,4.19-3.62,4.27-5.07 c0.08-1.45,2.06-1.3,2.06-1.3L421.91,218.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.5417,
    y1: -1444.7754,
    x2: 462.6825,
    y2: -1444.7754,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -769.7372 -753.6606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M426.41,147.93l-17.23-1.63c0,0-2.56,6.52-2.64,8.83c-0.49,15.36,14.37,58.42,14.37,58.42 s3.45-0.14,4.18-2.06c-0.15-0.02-9.08-40.41-7.76-55.54c0.24-2.77,5.98-0.16,5.98-0.16L426.41,147.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.621,
    y1: -1447.7981,
    x2: 464.0595,
    y2: -1447.7981,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -771.0592 -751.9086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M426.8,149.87c4.07,9.49-9.21,23.94-10.22,36.09c5.58,13.62,6.48,21.18,6.54,32.12 c-0.2,1.83-4.77,1.8-4.73,0.39c-1.26-10.64-4.73-17.64-8.75-32.26c-0.45-14.65,4.07-27.57,4.96-39.9 C418.63,147.71,425.11,145.93,426.8,149.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.6388,
    y1: -1402.9468,
    x2: 445.5043,
    y2: -1402.9468,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -746.1465 -765.4091)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M414.56,116.6c0,0-4.61,2.96-6.09,4.47c-1.9,3-0.2,12.48,0.6,16.31c0.23,1.08,0.1,2.21-0.34,3.22l-4.6,10.4 l1.88,4.36c3.2,5.18,7.05-3.66,6.78-10.68s-2.79-12.06-2.24-15.79c0.55-3.73,4.6-12.53,4.6-12.53L414.56,116.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.73,
    y1: -1402.7644,
    x2: 458.0581,
    y2: -1402.7644,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -743.9689 -758.0602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M427.95,148.63c0.66,1.33,1.34,2.83,1.94,4.53c0,0-10.39,5.92-14.01,4.13c-1.5-0.74-1.83-2.54-1.77-4.83 c0-0.11,0-0.22,0.01-0.33c0.12-3.2,0.9-7.28,0.37-10.85c-0.94-6.29-1.32-8.21,0.08-12.12c1.39-3.92,9.39-13.07,9.39-13.07l7.14,5.4 c0,0-0.86,2.59-1.93,5.88c-1.65,5.04-3.8,11.73-4.16,13.35c-0.2,0.91,0.04,1.91,0.54,3.07c0.25,0.61,0.58,1.28,0.95,2 C426.94,146.65,427.44,147.59,427.95,148.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.7317,
    y1: -1390.6937,
    x2: 450.0406,
    y2: -1390.6937,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -738.2693 -761.218)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M424.23,115.84l2.57,2.19l-7.58,7.69l-1.29-0.3l0.54,2.88c0,0-2.9,2.69-4.64,8.36 c-0.71-5.29,0.44-8.24,4.44-13.51C422.04,118.18,424.23,115.84,424.23,115.84z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M427.95,148.63c-1.8,1.13-3.57,2.32-5.02,3.86c-0.5,0.54-0.96,1.11-1.57,1.51c-1.15,0.77-2.68,0.76-4,0.31 c-0.98-0.32-1.87-0.88-2.71-1.48c-0.13-0.1-0.4-0.23-0.54-0.37c-0.03-0.03-0.05-0.05-0.07-0.08c-0.11-0.18-0.07-0.19,0.08-0.25 c0.03-0.02,0.07-0.04,0.12-0.06c0.44-0.21,0.87-0.4,1.3-0.61c0.88-0.43,1.75-0.88,2.6-1.36c1.71-0.96,3.36-2.02,4.94-3.17 c0.47-0.34,0.93-0.69,1.45-0.94c0.52-0.25,1.11-0.38,1.67-0.28c0.1,0.02,0.2,0.05,0.3,0.08 C426.94,146.65,427.44,147.59,427.95,148.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 431.7908,
    y1: -1414.667,
    x2: 442.9171,
    y2: -1414.667,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -752.1776 -758.6573)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M421.46,146.81c-0.73,0.26-1.68,0.39-1.68,0.39c-0.82-0.36-2.56-0.92-3.23-0.54s-1.14,1.26-1.75,1.63 c0.75,0.62,1.89-0.32,2.45-0.64c0.81,0.5,1.68,0.2,1.74,0.37c-0.85,0.16-2.72,1.62-4.45,1.42s-3.26,0.05-3.35,0.54 c1.85,1.48,2.31,2.83,3.97,2.64c1.65-0.2,3.58,0.66,4.86-1.29c0.6-1.75,0.99-1.88,1.55-2.29c0.56-0.4,1.88-0.95,1.88-0.95 L421.46,146.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.4756,
    y1: -1391.8093,
    x2: 440.5327,
    y2: -1391.8093,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -739.7084 -765.7598)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M410.99,118.27l4.41-2.43c0,0-4.93,9.76-4.65,14.03c0.28,4.28,0.25,4.79,0.86,6.81 c-1.37-2.08-2.67-6.97-2.38-10.05l1.82-1.44l-1.02-0.39L410.99,118.27z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M425.55,143.79c-0.39,0.55-0.92,1.01-1.52,1.31c-0.5,0.25-1.23,0.4-1.52-0.21c-0.2-0.39,0.06-0.61,0.08-0.99 c0.06-1.06-0.44-2.25-0.48-3.34c-0.08-2.33,0.43-4.68,1.52-6.73c1.33-2.53,3.44-4.53,5.54-6.46c-1.65,5.04-3.8,11.73-4.16,13.35 C424.81,141.63,425.05,142.63,425.55,143.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.0273,
    y1: -1345.6293,
    x2: 422.0284,
    y2: -1345.6293,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -718.161 -788.942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DB1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDFFFF"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 386.31,
    cy: 80.5,
    r: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.31,
    y1: 221.6284,
    x2: 406.92,
    y2: 221.6284,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M406.92,90.98c-3.56-0.76-6.77-2.73-9.37-5.1c2.93-2.9,4.76-6.92,4.76-11.38c0-8.84-7.16-16-16-16 s-16,7.16-16,16s7.16,16,16,16c2.47,0,4.79-0.57,6.88-1.57C398.05,91.34,402.98,91.78,406.92,90.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.9207,
    y1: -1400.2782,
    x2: 458.7576,
    y2: -1400.2782,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -742.2147 -754.5916)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B9D3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#90AAB7"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M431.11,121.5c2.53,1.82,5.78,14.69,6.37,19.44c0.08,0.9-11.1,8.04-15.09,9.12 c-2.24,0.58-2.99-2.65-1.74-3.45s7.3-5.83,10.94-7.83c-1.08-3.08-3.35-10.06-3.6-13.56C427.72,121.73,431.11,121.5,431.11,121.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.6449,
    y1: -1372.0765,
    x2: 443.4372,
    y2: -1372.0765,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -727.4336 -766.3708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M417.39,112.96c-2.6,1.17-4.35,1.03-4.54-0.09c-0.19-1.12-1.84-4.74-0.7-6.8s0-4.31,0-4.31 c0.82-2.06,2.42-2.5,2.42-2.5s6.84-0.88,8.15,4.56s-0.62,9.96-0.62,9.96L417.39,112.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.3889,
    y1: -1378.5646,
    x2: 453.6563,
    y2: -1378.5646,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -731.2598 -763.6058)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M410.6,99.88c2.09-3.94,9.93-7.57,13.84-2.35c5,2.62,3.65,6.64,2.15,11.71s0.02,10.26,2.29,13.2 c2.27,2.94-5.86,9.63-6.95,10.5c-0.09-4.44,2.34-12.56,0-14.13c-2.34-1.56-3.9-7.19-1.03-10.5s1.21-4.21-3.88-6.56 C413.06,103.61,410.81,101.44,410.6,99.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.7875,
    y1: -1340.4198,
    x2: 403.0378,
    y2: -1340.4198,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -716.3727 -793.0352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st64",
    cx: 381.31,
    cy: 74.8,
    r: 1.62
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.7875,
    y1: -1340.4199,
    x2: 408.0378,
    y2: -1340.4199,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -715.4685 -790.1674)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st65",
    cx: 386.31,
    cy: 74.8,
    r: 1.62
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.7875,
    y1: -1340.4198,
    x2: 413.0378,
    y2: -1340.4198,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -714.5642 -787.2994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st66",
    cx: 391.31,
    cy: 74.8,
    r: 1.62
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.3423,
    y1: -1506.5328,
    x2: 350.8529,
    y2: -1506.5328,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -824.0157 -801.5117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M318.16,217.98c0.52,2.87-1.77,16.42-2.02,22.96c-0.4,10.33-1.28,22.28-1.19,26.48 c-0.04,0.51-1.01,0.91-1.86,0.81c-0.63-0.08-1.19-0.43-1.29-1.2c-0.93-5.57-4.16-16.2-2.23-25.25c1.81-8.49-2.13-22.5-0.51-24.89 c0,0,2.21-1.66,5.63-0.68C315.75,216.5,316.9,217.06,318.16,217.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.3583,
    y1: -1506.6621,
    x2: 351.3316,
    y2: -1506.6621,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -823.7163 -800.2495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C27F6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCFBA"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M318.16,217.98c0.52,2.87-0.27,16.06-2.02,22.96c2.46,11.15-1.03,17.35-1.19,26.48 c-0.04,0.51-1.01,0.91-1.86,0.81c-0.07-1.27,0.6-2.21,0.49-3.48c-0.56-5.82,1-11.85,0.82-17.71c-0.17-5.04-2.62-10.43-0.92-15.17 c0.25-0.72,0.56-1.41,0.72-2.16c0.24-1.23,0.03-2.49-0.01-3.75c-0.1-3.21,1.02-6.37,0.53-9.57c0-0.06-0.02-0.13-0.02-0.19 C315.75,216.5,316.9,217.06,318.16,217.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.7639,
    y1: 22.795,
    x2: 313.7639,
    y2: 30.304,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M312.47,266.72c1.41-0.79,2.51-0.61,3.4,0.69c0.89,1.3,1.68,5.22,0.6,5.86c-1.08,0.64-5.48,0.85-5.86-0.65 C310.22,271.12,311.43,267.3,312.47,266.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.3069,
    y1: -1473.1958,
    x2: 334.8411,
    y2: -1473.1958,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -804.713 -808.3632)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M307.79,204.73l1.43,0.89c0,0,1.16-1.16,1.87-1.11c0.7,0.04,2.43,1.24,2.94,1.07 c0.7,1.47,0.96,1.8,1.23,1.93c-0.74,0.22-1.54-0.42-1.8-1.02c-0.77-0.26-1.61-0.43-1.61-0.43c0.43,0.75,1.48,2.91,2.9,2.99 c1.42,0.08,3.04,1.47,2.8,1.77c-0.96,0.4-1.74,0.98-2.75,0.66c-1.02-0.32-3.4-0.32-4.3-1.45c-0.9-1.13-1.72-1.93-2.12-2.33 c-0.4-0.41-1.48-0.91-1.48-0.91L307.79,204.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.598,
    y1: -1456.8905,
    x2: 329.2823,
    y2: -1456.8905,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -796.986 -819.0253)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M308.87,205.4c-0.02,0.75-0.32,1.56-0.82,2.03c-0.37,0.34-0.85,0.5-1.41,0.3c-2.6-0.94-8.76-5.6-8.76-5.6 c-5.77-3.97-8.45-6.61-8.37-8.37c0,0,0.73-11.79,5.45-20.26c0.89-1.61,8.33,1.84,6.52,3.42c-0.36,0.31-0.78,0.93-1.23,1.75 c-2.31,4.26-5.43,13.96-5.43,14.66c1.51,1.01,4.63,3.58,7.57,5.95c2.42,1.96,4.71,3.8,5.87,4.53 C308.72,204.1,308.91,204.73,308.87,205.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.1625,
    y1: -1474.7363,
    x2: 333.6516,
    y2: -1474.7363,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -806.4254 -810.1877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M312.43,205.99l-1.32,1.06c0,0-1.29-1.01-1.99-0.89c-0.69,0.13-2.27,1.51-2.8,1.41 c-0.53,1.54-0.74,1.9-0.99,2.06c0.76,0.13,1.48-0.59,1.67-1.22c0.73-0.34,1.55-0.62,1.55-0.62c-0.34,0.79-1.13,3.07-2.53,3.31 c-1.4,0.25-2.85,1.81-2.58,2.08c1,0.29,1.84,0.77,2.81,0.33c0.97-0.43,3.34-0.71,4.1-1.94s1.48-2.11,1.84-2.57 c0.35-0.45,1.36-1.08,1.36-1.08L312.43,205.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.3835,
    y1: -1454.6904,
    x2: 351.1068,
    y2: -1454.6904,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -793.7197 -807.0995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M327.43,188.9c0.91,3.96,0.98,5.87-0.51,8.16c-3.42,5.27-10.53,10.54-13.01,11.78 c-1.89,0.94-3.3-2.69-2.07-3.7c2.35-1.92,7.38-6.66,9.89-8.82c1.2-1.03,0.53-4.83,0.06-6.34c-1.02-3.25-3.91-10.67-6.35-12.34 c-1.98-1.36,6.08-4.16,6.08-4.16S326.13,183.26,327.43,188.9z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M315.82,178.19c2.44,1.67,4.96,8.55,5.98,11.79c0.47,1.51,1.14,5.31-0.06,6.34 c-2.51,2.16-7.54,6.9-9.89,8.82c-0.44,0.36-0.54,1.05-0.41,1.75c0.92-0.36,2.51-1.58,3.03-1.87c2.56-1.45,4.43-3.81,6.52-5.88 c1.41-1.4,3.01-2.82,3.42-4.77c0.37-1.73-0.31-3.5-0.97-5.14c-1.25-3.1-4.07-10.17-6.13-12.77 C316.02,177.26,315.13,177.72,315.82,178.19z"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M302.39,199.28c-0.03,0.7-0.13,1.4-0.29,2.08c-2.46-2.23-4.92-4.45-7.37-6.68c-0.41-0.37-0.83-0.76-1.03-1.27 c-0.25-0.61-0.15-1.29-0.04-1.93c0.23-1.47,0.47-2.93,0.77-4.39c0.5-2.51,1.17-5.01,2.26-7.33c0.38-0.81,0.92-2.55,2.06-2.36 c0.62,0.11,1.16,0.65,1.5,1.27c-2.31,4.26-5.43,13.96-5.43,14.66C296.33,194.34,299.45,196.91,302.39,199.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.4402,
    y1: -1506.2239,
    x2: 343.0846,
    y2: -1506.2239,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -825.4258 -806.0715)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M310.55,218.11c0.43,2.89-2.27,16.36-2.72,22.89c-0.71,10.31-1.96,22.23-2,26.43 c-0.05,0.51-1.03,0.88-1.89,0.76c-0.63-0.1-1.18-0.46-1.25-1.24c-0.76-5.6-3.66-16.32-1.46-25.31c2.07-8.43-1.44-22.56,0.25-24.9 c0,0,2.26-1.59,5.65-0.5C308.18,216.56,309.32,217.15,310.55,218.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.3785,
    y1: -1506.6512,
    x2: 343.5157,
    y2: -1506.6512,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -825.2131 -805.0161)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C27F6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCFBA"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M310.55,218.11c0.43,2.89-0.76,16.05-2.72,22.89c2.12,11.22-1.56,17.31-2,26.43 c-0.05,0.51-1.03,0.88-1.89,0.76c-0.03-1.27,0.67-2.19,0.59-3.46c-0.38-5.84,1.36-11.82,1.36-17.67c-0.01-5.04-2.3-10.5-0.46-15.19 c0.27-0.71,0.6-1.39,0.78-2.14c0.28-1.22,0.1-2.49,0.1-3.74c0-3.21,1.21-6.34,0.82-9.55c0-0.06-0.01-0.13-0.02-0.19 C308.18,216.56,309.32,217.15,310.55,218.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.5869,
    y1: -1483.2087,
    x2: 345.3254,
    y2: -1483.2087,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -811.7827 -808.4105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8A183"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4307,
    style: {
      stopColor: "#E8A285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5859,
    style: {
      stopColor: "#EAA88C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6965,
    style: {
      stopColor: "#ECB197"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7859,
    style: {
      stopColor: "#EFBDA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#F3CEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9302,
    style: {
      stopColor: "#F8E3DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9901,
    style: {
      stopColor: "#FEFAF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M317.74,234c-0.62,1.53-2.97,1.55-6.26,1.69c-5.04,0.22-9.83-0.28-11.06-2.46 c-2.63-9.02-4.5-18.74-4.02-24.07c0.21-2.44,0.64-4.57,1.12-6.45l19.94,0.29c0,0,1.17,1.32,2.55,2.89 C321.64,211.79,321.18,222.8,317.74,234z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M317.74,234c-0.62,1.53-2.97,1.55-6.26,1.69c1.29-2.22,3.81-7.54,4.42-11.63c0.54-3.62,0.92-8.75,0.67-13.8 c-2.62,1-6.37,1.04-8.03-0.32c-0.65,1.48-2.82,1.43-7.99,0.35c-2.18-0.46-3.45-0.77-4.15-1.14l1.12-6.45l19.94,0.29 c0,0,1.17,1.32,2.55,2.89C321.64,211.79,321.18,222.8,317.74,234z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.5624,
    y1: -1455.0765,
    x2: 347.5265,
    y2: -1455.0765,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -794.3655 -814.3745)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M321.03,206.51c-0.65,1.13-1.48,1.44-3.23,1.79c-2.27,0.46-5.16,0.66-7.07,0.27 c-0.79-0.16-2.51-2.71-2.51-2.71s-1.42,3.07-2.27,3c-5.19-0.45-8.79-1.22-9.52-3.64l2.83-6.01c2.04-4.6,1.58-7.06,0.65-11.99 c-1.84-9.69-6.52-8.45-5.62-12.44c0.79-3.51,6.89-2.3,12.1-5.93c0.36-1.42,5.82,0.93,5.82,0.93l9.38,3.69l-1.51,6.3l-2.27,9.48 c-0.87,4.07-0.66,7.63,1.16,11.37C320.54,203.91,319.94,203.25,321.03,206.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.4077,
    y1: 26.5874,
    x2: 307.8598,
    y2: 26.5874,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M303.14,266.74c1.38-0.85,2.49-0.71,3.42,0.55c0.94,1.26,1.89,5.15,0.84,5.83c-1.06,0.68-5.44,1.07-5.89-0.41 C301.07,271.23,302.13,267.36,303.14,266.74z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M321.03,206.51c-0.65,1.13-1.75,1.49-3.5,1.84c0.93-4.63-3.64-6.83-4.27-13.18 c-0.66-6.72,1.34-12.14,6.24-13.19l-1.7,7.27c-0.87,4.07-0.66,7.63,1.16,11.37C320.54,203.91,319.94,203.25,321.03,206.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.6309,
    y1: -1429.1753,
    x2: 341.1556,
    y2: -1429.1753,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -780.463 -818.5328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C07F4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCAA0"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M310.33,177.58c-0.54,0.29-1,0.65-1.31,1.13c-0.67,1.01-1.55,1.49-2.5,1.53c0.08-0.68,0.24-1.39,0.44-2.09 c-2.5-2.28-9-1.2-8.26-5.61c0.77-4.67,2.83-6.11,1.67-12.04c-1.14-5.77,0.95-10.35,5.27-11.49c1.09-0.29,2.09-0.31,2.96-0.2 c1.85,0.23,3.08,1.03,3.16,0.98c0.12,0.08,0.25,0.15,0.38,0.24c4.43,0.57,5.09,4.7,3.96,10.47c-1.16,5.93,0.89,7.37,1.67,12.04 C318.43,176.52,313.19,176.03,310.33,177.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.157,
    y1: 132.9507,
    x2: 325.657,
    y2: 136.2007,
    gradientTransform: "matrix(1 0 0 -1 0 296.5511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3402E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2BD94"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M310.33,177.58c-0.64-0.19-1.21-0.5-1.61-1.05c-0.71-0.99-0.55-2.37-0.03-3.47c0.53-1.09,1.36-2.01,1.99-3.05 c1.41-2.29,1.8-5.19,1.05-7.77c-0.34-1.18-0.9-2.32-0.92-3.54c-0.02-1.1,0.4-2.15,0.57-3.24c0.26-1.66-0.11-3.41-1.02-4.82 c-0.48-0.75-1.09-1.29-1.76-1.83c1.85,0.23,3.08,1.03,3.16,0.98c0.12,0.08,0.25,0.15,0.38,0.24c4.43,0.57,5.09,4.7,3.96,10.47 c-1.16,5.93,0.89,7.37,1.67,12.04C318.43,176.52,313.19,176.03,310.33,177.58z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.1285,
    y1: -1463.1227,
    x2: 419.8973,
    y2: -1463.1227,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -786.8804 -767.9445)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M391.61,195.68c0.02,0.04,0.03,0.08,0.03,0.08c-0.33,5.15-4.86,13.28-6.48,16.37 c-0.05,0.11-0.11,0.21-0.16,0.31c-0.02-0.01-0.03-0.01-0.05-0.02c-0.07,0.64-0.2,1.75-0.21,3.16c-0.01,1.53-2,3.1-2.64,4.03 s-1.67,0.96-2.74,1.26c-0.4-0.09,0.05-2.31,1.18-3.32c1.13-1,0.58-3.49,0.45-4.39c0,0-0.59,0.7-1.07,1.42 c0.18,0.67-0.07,1.73-0.83,2.03c0.14-0.29,0.13-0.73-0.25-2.41c0.54-0.2,1.2-2.34,1.76-2.83c0.57-0.5,2.29-0.3,2.29-0.3l0.06-0.18 c0-0.08,0.02-0.13,0.02-0.13c0.32-3.5,1.95-12.2,4.28-16.06c0-0.01,0-0.01,0.01-0.01c-0.18-0.42-0.36-0.86-0.52-1.39 c-1.75-5.68-3.68-14.21-3.68-14.21l3.4,0.43l2.96,0.38c1.03,4.8,2.3,12.44,2.22,15.34C391.64,195.38,391.63,195.53,391.61,195.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.8025,
    y1: -1534.2367,
    x2: 391.5028,
    y2: -1534.2367,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -829.3657 -765.4965)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M366.64,264.65c1.69-0.86,2.97-0.58,3.94,0.99c0.97,1.57,1.7,6.21,0.4,6.9c-1.3,0.69-6.46,0.71-6.83-1.07 C363.77,269.68,365.4,265.27,366.64,264.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.2316,
    y1: -1533.8444,
    x2: 407.7244,
    y2: -1533.8444,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -826.2003 -756.2075)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#747F8D"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M382.98,264.37c1.65-0.83,2.9-0.56,3.85,0.96c0.95,1.53,1.65,6.06,0.39,6.73c-1.27,0.67-6.31,0.69-6.67-1.04 C380.19,269.28,381.77,264.98,382.98,264.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.1256,
    y1: -1423.1029,
    x2: 405.045,
    y2: -1423.1029,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -764.1667 -780.7994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M370.12,158.6l0.61,9.88v0.06h6.2l-0.28-5.44c1.44,0.32,2.75-0.03,3.27-0.01c1.22,0.05,2.39-2.77,2.39-4.21 c0-2.81-0.63-3.03-0.49-6.1c0.15-3.07-0.64-6.08-4.72-6.28c0,0-0.74,1.07-1.71,2.63c-1.82,2.94-4.44,7.63-4.35,10.08L370.12,158.6z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M370.12,158.6l0.61,9.88c0.12,0.02,0.23,0.04,0.35,0.06c1.34,0.23,2.69,0.45,3.99,0.72 c-0.15-0.23-0.28-0.47-0.38-0.72c-0.94-2.23-0.18-5.11,1.84-6.48c0.53-0.37,1.14-0.63,1.6-1.08s0.76-1.16,0.49-1.74 c-0.32-0.66-1.22-0.87-1.58-1.51c-0.39-0.69,0-1.55,0.39-2.24c1.2-2.13,2.41-4.25,3.61-6.38c-1.93,0.17-3.57-0.17-5.49,0.01 c-0.05,0-0.11,0.01-0.16,0.01c-1.82,2.94-4.44,7.63-4.35,10.08L370.12,158.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.9612,
    y1: -1417.0905,
    x2: 403.7098,
    y2: -1417.0905,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -761.9436 -782.9299)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEA94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB53F"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M377.95,144.14c0.2-2.21-2.59-1.59-7.17,0.41c-4.58,2-3.04,5.59-3.38,6.34c-1.75,1.17-1.25,4.88-0.33,6.53 c0.92,1.64,3.01,2.22,3.33,5.63c3.13,0.8,3.2-5.41,2.86-6.76c-0.33-1.36,0.86-3.62,3.3-0.44c1.42-2.08,0.12-3.58,0.37-4.25 c2-1.42,4.41-1.74,4.72-4.24C381.97,144.86,377.95,144.14,377.95,144.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.0087,
    y1: -1456.1445,
    x2: 392.9893,
    y2: -1456.1445,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -785.4183 -783.6677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE9D1"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M366.54,208.04c-4.09-2.44-9.86-11.48-12.11-14.17c-2.04-2.84,4.01-19.26,5.41-22.33 c2.54,0.47,5.14,2.56,5.14,2.56s-3.47,12.96-5.91,17.33c2.65,1.85,9,15,9,15L366.54,208.04z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M365.09,175.03c0,0-1.84,7.83-2.47,8.96s-7.47-1.66-6.94-3.23c0.53-1.58,4.44-12.2,4.44-12.2L365.09,175.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.1004,
    y1: -1459.5109,
    x2: 418.0914,
    y2: -1459.5109,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -783.9446 -766.929)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C27F6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCFBA"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M391.61,195.68c0.02,0.04,0.03,0.08,0.03,0.08c-0.33,5.15-4.86,13.28-6.48,16.37 c-0.2-0.59-0.17-1.32-0.07-1.96c0.49-2.92,4.44-11.87,5.11-14.76c-2.01-4.81,0.87-3.89-3.02-15.6c-0.35,0.9-0.36,0.83-0.12,1.76 c-0.31-0.64-0.5-1.34-0.58-2.05l2.96,0.38c1.03,4.8,2.3,12.44,2.22,15.34C391.64,195.38,391.63,195.53,391.61,195.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.884,
    y1: -1498.5024,
    x2: 420.5127,
    y2: -1498.5024,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -806.9585 -764.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90AAB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9D3C1"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M386.83,265.33c0.09,0.87-0.33,1.43-0.96,1.72c-1.34,0.61-3.64-0.03-4.18-1.77c-0.8-2.56-3-22.62,0.17-30.48 c-1.63-8.75-10.17-28.98-8.67-33.03c1.26-3.41,6.98-1.61,8.76-0.96c0.34,0.13,0.54,0.21,0.54,0.21c4.03,5.67,5.49,19.66,5.26,33.78 C389.29,245.76,386.56,262.62,386.83,265.33z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M386.83,265.33c0.09,0.87-0.33,1.43-0.96,1.72c-1.02-3.79-1.03-7.81-0.67-11.74 c0.41-4.53,1.31-9.01,1.64-13.55c0.32-4.35-1.87-8.55-2.39-12.78c-0.96-7.8-1.03-15.41-3.26-22.93c-0.27-0.92-1.32-3.12-0.23-3.87 c0.34-0.24,0.67-0.78,0.99-1.37c0.34,0.13,0.54,0.21,0.54,0.21c4.03,5.67,5.49,19.66,5.26,33.78 C389.29,245.76,386.56,262.62,386.83,265.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.6144,
    y1: -1497.2966,
    x2: 412.1554,
    y2: -1497.2966,
    gradientTransform: "matrix(0.8192 -0.5736 -0.5736 -0.8192 -808.9196 -771.0117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90AAB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9D3C1"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M375.11,201.37v11.31c0,0-2.21,12.54-4.05,22.42c1.84,5.87,0.69,24.87-0.49,29.62 c-0.04,0.16-0.14,0.34-0.28,0.51c-0.98,1.22-4.09,2.33-5.02-0.51c-1.13-4.71-1.66-18.17-0.6-30.29 c-1.27-10.97-1.94-23.82,1.19-34.17L375.11,201.37z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M391.36,183.43c0.16,0.82-1.47,1.65-3.2,2.14c-1.74,0.49-3.59,0.62-3.83,0.01c-0.3-0.78-1.28-4.06-1.94-6.26 c-0.34-1.19-0.6-2.07-0.6-2.07l0.78-0.83l2.5-2.61l2.75-2.9C387.82,170.91,391.05,181.8,391.36,183.43z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M382.67,186.66c-0.46,2.34,0.4,10.01,0.06,13.65c-0.11,1.17-1.42,2.02-3.28,2.55 c-4.56,1.3-12.42,0.64-13.66-1.96c-0.09-0.19-0.14-0.38-0.16-0.59c-0.31-3.83-1.1-12.41-1.74-16.03l-3.74-15.73 c0,0,5.04-1.9,10.54-2.36c1,2.7,5.52,1.72,6.23,0c0.74,0,4.27,1.39,6.96,2.65c0.57,0.27,1.09,0.54,1.55,0.78 c1.38,0.73,2.39,1.29,2.39,1.29l-4.51,5.51C383.31,176.42,383.15,184.28,382.67,186.66z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M375.11,212.68c0,0-2.21,12.54-4.05,22.42c1.84,5.87,0.69,24.87-0.49,29.62c-0.04,0.16-0.14,0.34-0.28,0.51 c-0.59-1.08-0.68-2.49-0.7-3.76c-0.16-11.77,0.04-23.55,0.6-35.31c0.13-2.73,0.28-5.47,0.92-8.13c0.44-1.86,1.37-5.42,3.08-6.56 c0.4-0.27,0.7-0.26,0.92-0.09L375.11,212.68L375.11,212.68z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M382.67,186.66c-0.46,2.34,0.4,10.01,0.06,13.65c-0.11,1.17-1.42,2.02-3.28,2.55 c-4.56,1.3-12.42,0.64-13.66-1.96c0.32,0.07,0.66,0.16,1.01,0.21c3.01,0.47,10.27,0.54,12.04-1.82c2.06-2.73,1.88-7.22,1.33-10.79 c-0.7-4.51-0.16-9.41,0.79-13.87c0.31-1.47,0.64-2.98,1.45-4.26c0.38-0.59,0.88-1.12,1.47-1.52c0.57,0.27,1.09,0.54,1.55,0.78 c1.38,0.73,2.39,1.29,2.39,1.29l-4.51,5.51C383.31,176.42,383.15,184.28,382.67,186.66z"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M385.76,178.58c-0.69,2.39-0.4,5.05,0.77,7.25c-0.64,0.19-1.43,0.3-1.88-0.18c-0.18-0.19-0.27-0.44-0.35-0.68 c-0.82-2.33-0.25-0.71-1.07-3.04c-0.06-0.17,0.01-3.73,0.06-3.91c0.04-0.14-0.07-1.49,0.03-1.59c1.02-1.07,1.04-1.46,2.06-2.53 c0.74-0.78,1.35-2.21,2.3-2.64c0.22,0.77-0.16,2.19-0.35,2.96C386.96,175.71,386.19,177.09,385.76,178.58z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjets);
export default __webpack_public_path__ + "static/media/projets.84dbe355fbaa7ab28de4fb3bc8dbf84b.svg";
export { ForwardRef as ReactComponent };